// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { IOfferBadgeSchema } from '../offer_badge/OfferBadgeSchema';
import type { IHotelDataSchema } from '../hotel_data/HotelDataSchema';
import type { IOfferButtonSchema } from '../offer_button/OfferButtonSchema';
import type { IPartnerDataSchema } from '../partner_data/PartnerDataSchema';
import type { IPaymentSummarySchema } from '../payment_summary/PaymentSummarySchema';
import type { IRatingSchema } from '../rating/RatingSchema';

export interface IExtendedDataSchema {
  /** Тип действия для кнопки **/
  actionType: EActionType;
  /** Бейдж доступности **/
  badge?: IOfferBadgeSchema;
  /** Данные о отеле **/
  hotelData: IHotelDataSchema;
  /** Есть ли подключение ОТА **/
  isOnlineBooking: boolean;
  /** Проверено ЦИАН **/
  isVerifiedByCian: boolean;
  /** Кнопка для футера карточки объявления **/
  offerButton?: IOfferButtonSchema;
  /** Тайтл кнопки **/
  offerButtonTitle?: string;
  /** Список лейблов для объявления **/
  offerLabels: EOfferLabels[];
  /** Данные о партнёре **/
  partner?: IPartnerDataSchema;
  /** Саммари по оплате **/
  paymentSummary?: IPaymentSummarySchema;
  /** Форматированная цена **/
  price: string;
  /** Рейтинг и кол-во отзывов у объявления **/
  rating?: IRatingSchema;
  /** Идентификатор объявления **/
  realtyId: number;
  /** Показывать ли пользователю кнопку настроек календаря Циан для этого объявления **/
  showBookingCalendarSettings: boolean;
  /** Флаг показываем ли блок все отзывы и оценки **/
  showFullRating: boolean;
  /** Идентификатор поездки **/
  tripId?: number;
}

export enum EActionType {
  /** Смотреть заявку на бронирование **/
  'BookingRequestView' = 'bookingRequestView',
  /** Возможность написать в чат **/
  'Chat' = 'chat',
  /** Возможность связаться напрямую **/
  'Contact' = 'contact',
  /** Бронирование **/
  'OtaBooking' = 'otaBooking',
  /** Проверка дат **/
  'OtaCheckDates' = 'otaCheckDates',
  /** Забронировать партнёрский объект **/
  'PartnerBooking' = 'partnerBooking',
  /** Проверка дат у партнёрского объекта **/
  'PartnerCheckDates' = 'partnerCheckDates',
}
export enum EOfferLabels {
  /** Мгновенное бронирование **/
  'InstantBooking' = 'instantBooking',
}
